import Keyword from "./Keyword";

export default Keyword;
